import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isEditPage, isRelistPage } from '../../helpers/router.helper';

@Component({
    selector: 'property-information-notice',
    templateUrl: './property-information-notice.component.html',
    styleUrls: ['./property-information-notice.component.scss']
})
export class PropertyInformationNoticeComponent implements OnInit {

    noticeMessage: string;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        if (isEditPage(this.route)) {
            this.noticeMessage = `It is not possible to change the address, bedrooms and bathrooms 
            once the property has been live on site for 7 days.`;
        } else if (isRelistPage(this.route)) {
            this.noticeMessage = 'It is not possible to change the address, bedrooms and bathrooms when relisting a property.';
        }
    }
}
